import React from 'react';
import { useSeo } from '@/lib/seo';

export default function AboutPage() {
  useSeo({
    title: 'About Us',
    description: 'CalculateEasy is a growing collection of free, transparent, mobile-friendly calculators built for everyday questions.',
    path: '/about',
  });
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 prose prose-slate">
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900">About CalculateEasy</h1>
      <p className="text-lg text-slate-600 mt-4">
        CalculateEasy is a growing library of free online calculators. Our goal is simple: give you an accurate answer to an everyday question in seconds, and show enough of the math that you can trust it.
      </p>
      <h2>Why we built this</h2>
      <p className="text-slate-600">
        Most calculator sites either bury the tool under ads or hide the formula behind a paywall. We wanted a home for the boring-but-essential everyday math — percentages, ages, bills, savings goals — that just works, especially on a phone.
      </p>
      <h2>What we promise</h2>
      <ul className="text-slate-600">
        <li><strong>Accurate:</strong> Every calculator is built from published formulas and tested with known inputs.</li>
        <li><strong>Original content:</strong> Explanations, examples, and FAQs are written by us — not scraped or auto-generated in bulk.</li>
        <li><strong>Non-intrusive advertising:</strong> When we display ads, they will never sit next to a calculator button or input.</li>
        <li><strong>Not professional advice:</strong> Financial, tax, legal, and medical calculators are for information only.</li>
      </ul>
      <h2>Contact</h2>
      <p className="text-slate-600">Questions or a tool you'd like us to build? Reach us on our <a href="/contact" className="text-emerald-700">contact page</a>.</p>
    </article>
  );
}
